// ============================================================================
// RECOVERY OFFICER DASHBOARD SERVICE — Phase 8.D
// ============================================================================

import { get } from '../client/axiosClient';
import { recoveryDashboardEndpoints } from '../endpoints/recoveryDashboard.endpoints';
import type { ApiResponse } from '../types';
import type {
  ActionTodayItem,
  RecentClosureItem,
  UnclaimedQueueItem,
  WorkloadSummary,
} from '../types/recoveryDashboard.types';

class RecoveryDashboardService {
  async getMyWorkload(): Promise<WorkloadSummary> {
    const res = await get<ApiResponse<WorkloadSummary>>(
      recoveryDashboardEndpoints.myWorkload(),
    );
    return res.data.data ?? { totalOpen: 0, byStage: [] };
  }

  async getUnclaimedQueue(limit?: number): Promise<UnclaimedQueueItem[]> {
    const res = await get<ApiResponse<UnclaimedQueueItem[]>>(
      recoveryDashboardEndpoints.unclaimedQueue(limit),
    );
    return res.data.data ?? [];
  }

  async getActionToday(limit?: number): Promise<ActionTodayItem[]> {
    const res = await get<ApiResponse<ActionTodayItem[]>>(
      recoveryDashboardEndpoints.actionToday(limit),
    );
    return res.data.data ?? [];
  }

  async getRecentClosures(days?: number, limit?: number): Promise<RecentClosureItem[]> {
    const res = await get<ApiResponse<RecentClosureItem[]>>(
      recoveryDashboardEndpoints.recentClosures(days, limit),
    );
    return res.data.data ?? [];
  }
}

export const recoveryDashboardService = new RecoveryDashboardService();
export default recoveryDashboardService;
